module.exports = "<?php\nnamespace Tests\\AppBundle\\Controller;\n\nuse Symfony\\Bundle\\FrameworkBundle\\Test\\WebTestCase;\n\nclass MovieControllerTest extends WebTestCase\n{\n    public function testIndex()\n    {\n        $client = static::createClient();\n\n        $crawler = $client->request('GET', '/');\n\n        $this->assertEquals(\n            200, // or Symfony\\Component\\HttpFoundation\\Response::HTTP_OK\n            $client->getResponse()->getStatusCode()\n        );\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/test-functional.txt
// module id = 662
// module chunks = 210681221719129